export default __webpack_public_path__ + "static/phonesTilted-ae16ac90b0753494eaa08e3184d16a8a.png";